export default __webpack_public_path__ + "static/media/portfolio4.6bf60cbb.jpg";